import { convertDate, getDateTimeColumn } from "./DateTimeValidation";

/**
 * SINCE THERE ARE THREE CODES IN THIS TABLE, WE HANDLE IT DIFFERENTLY
 * ALL BUT NIGHTS ARE [B986, B988] AND NIGHTS ARE [B986, B987]
 * CHECK SOB PG 91 FOR FULL TABLE
 */


const anyColumnButNights = [
    {
        code: 'B986',
        price:36.4,
        name: 'Geriatric Travel Premium',
        applicable: false,
        reason:'',
        validate({self, newApt}){
            if(!newApt.performedTravel){
                self.applicable = false;
                self.reason = 'Physician did not travel.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
    {
        code: 'B988',
        price:82.5,
        name: 'Geriatric First Person Seen Premium',
        applicable: false,
        reason:'',
        validate({self, newApt}){
            if(!newApt.firstPersonSeen){
                self.applicable = false;
                self.reason = 'Patient is not first seen.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
];

const nights = [
    {
        code: 'B986',
        price:36.4,
        name: 'Geriatric Travel Premium',
        applicable: false,
        reason:'',
        validate({self, newApt}){
            if(!newApt.performedTravel){
                self.applicable = false;
                self.reason = 'Physician did not travel.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
    {
        code: 'B987',
        price: 110,
        name: 'Geriatric First Person Seen Nights Premium',
        applicable: false,
        reason:'',
        validate({self, newApt}){
            if(!newApt.performedTravel){
                self.applicable = false;
                self.reason = 'Physician did not travel.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
];


export function getGeriatricColumn(newApt){
    const dateObject = convertDate(newApt.date, newApt.time);
    const columnType = getDateTimeColumn(dateObject);

    if (columnType == 'nights') return nights;
    else return anyColumnButNights;
}